import type { ScaAllowedValues } from '@data/global-api-payments';

export const transformGlobalApiScaMethodsForDataLayer = (
  scaMethods?: ScaAllowedValues[]
) => {
  if (!scaMethods) {
    return;
  }

  return scaMethods.map(({ description, name, value }) => ({
    id: value,
    type: name,
    description,
  }));
};
